import { useSyncExternalStore } from 'react'
import { obtenerEstado, suscribir, type EstadoSesion } from './almacen'

/**
 * El estado de sesion como estado de React, sin duplicarlo.
 *
 * Se llama useSesion y no usarSesion, contra la convencion de nombrar en
 * espanol, porque las Rules of React exigen el prefijo "use": el React
 * Compiler y su linter reconocen los hooks por el nombre. Es el unico lugar
 * donde el ingles gana.
 */
export function useSesion(): EstadoSesion {
  return useSyncExternalStore(suscribir, obtenerEstado, obtenerEstado)
}
